import { render, staticRenderFns } from "./ModalReprovar.vue?vue&type=template&id=0cf5a6fe"
import script from "./ModalReprovar.vue?vue&type=script&lang=js"
export * from "./ModalReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports